<template>
  <div v-if="visible" class="modal-overlay" @click="emitClose">
    <div class="plate-kline-modal" @click.stop>
      <div class="plate-kline-header">
        <h4>{{ plateName }} ({{ plateCode }})</h4>
        <button class="close-btn" @click="emitClose">&times;</button>
      </div>
      <StockKlineDay
        :symbol_code="plateCode"
        :title="plateName"
        :subText="plateCode"
        :highlightDate="selectedDate"
        :chart_heigh="'400px'"
        :zoom_start="40"
      />

      <div class="plate-reasons">
        <div class="plate-reasons-header">
          <h5>板块爆发原因</h5>
          <span v-if="loadingReasons" class="loading">加载中...</span>
        </div>
        <div v-if="!loadingReasons && authRequired" class="empty">需要登录后查看板块爆发原因 <b-button size="sm" variant="outline-primary" class="login-btn" @click="goLogin">去登录</b-button></div>
        <div v-else-if="!loadingReasons && reasons.length === 0" class="empty">暂无数据</div>
        <div v-else class="reasons-list">
          <div class="reason-item" v-for="(r, idx) in reasons" :key="r.newid || idx">
            <div class="reason-title">
              <span class="date">{{ r.date }}</span>
              <span class="boom" v-if="r.isboom">爆发</span>
              <a href="#" class="title" @click.prevent="toggleReason(r)">{{ r.title }}</a>
            </div>
            <div class="reason-meta">
              <span v-if="r.ztnum != null">涨停数：{{ r.ztnum }}</span>
              <span v-if="r.index != null">指数：{{ r.index }}</span>
              <span v-if="r.qd != null">强度：{{ r.qd }}</span>
            </div>
            <div class="reason-text" v-if="r.boomreason">{{ r.boomreason }}</div>
            <div class="reason-lz" v-if="r.lzinfo">龙头：{{ r.lzinfo }}</div>
            <div class="reason-content" v-if="expanded[r.newid]">
              <div v-if="loadingContent[r.newid]" class="loading">内容加载中...</div>
              <div v-else>
                <div class="reason-detail-meta" v-if="contentMap[r.newid] && contentMap[r.newid].createTime">
                  时间：{{ formatTimestamp(contentMap[r.newid].createTime) }}
                </div>
                <div v-html="contentMap[r.newid] && contentMap[r.newid].content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StockKlineDay from 'components/stock/StockKlineDay.vue'
import { request_zzquant } from 'network/request.js'

export default {
  name: 'PlateKlineModal',
  components: { StockKlineDay },
  props: {
    visible: { type: Boolean, default: false },
    plateCode: { type: String, required: true },
    plateName: { type: String, required: true },
    selectedDate: { type: String, default: null }
  },
  data() {
    return {
      reasons: [],
      loadingReasons: false,
      authRequired: false,
      contentMap: {},
      loadingContent: {},
      expanded: {}
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadReasons()
      }
    },
    plateCode(newCode, oldCode) {
      if (this.visible && newCode && newCode !== oldCode) {
        this.loadReasons()
      }
    }
  },
  mounted() {
    try { window.addEventListener('user-login', this.onUserLogin) } catch (e) { /* ignore */ }
    // 组件首次以可见状态挂载时，需要主动加载原因列表
    if (this.visible && this.plateCode) {
      this.loadReasons()
    }
  },
  beforeDestroy() {
    try { window.removeEventListener('user-login', this.onUserLogin) } catch (e) { /* ignore */ }
  },
  methods: {
    emitClose() {
      this.$emit('close')
    },
    goLogin() {
      try {
        const current = this.$route && this.$route.fullPath ? this.$route.fullPath : '/'
        this.$router.push({ path: '/login', query: { redirect: current } })
      } catch (e) {
        // ignore
      }
    },
    formatTimestamp(ts) {
      if (!ts) return ''
      const num = typeof ts === 'number' ? ts : parseInt(ts, 10)
      if (!num) return ''
      const d = new Date(num * 1000)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hh = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      return `${y}-${m}-${day} ${hh}:${mm}`
    },
    loadReasons() {
      if (!this.plateCode) return
      this.loadingReasons = true
      this.authRequired = false
      try {
        const tk = localStorage.getItem('token')
        if (!tk) this.authRequired = true
      } catch (e) { /* ignore */ }
      request_zzquant({
        url: `/market/plate/popular/reason?plate_code=${this.plateCode}`,
        noRedirect: true
      })
        .then(res => {
          const data = res && res.data && res.data.data ? res.data.data : []
          this.reasons = Array.isArray(data) ? data : []
          // 清空展开与内容状态（避免切换板块遗留）
          this.contentMap = {}
          this.loadingContent = {}
          this.expanded = {}
        })
        .catch(err => {
          console.log(err)
          const msg = (err && err.message) ? String(err.message) : ''
          const hints = ['无权限','未登录','验证失败','Unauthorized','需要登录','未授权']
          const status401 = !!(err && err.status === 401)
          const unauthorized = !!(err && err.__unauthorized)
          const byMsg = hints.some(h => msg.indexOf(h) !== -1)
          this.authRequired = !!(status401 || unauthorized || byMsg)
          this.reasons = []
        })
        .finally(() => {
          this.loadingReasons = false
        })
    },
    toggleReason(r) {
      const id = r.newid
      if (!id) return
      // 如果已展开，则收起
      if (this.expanded[id]) {
        this.$set(this.expanded, id, false)
        return
      }
      // 未展开，若已有内容则直接展开
      if (this.contentMap[id]) {
        this.$set(this.expanded, id, true)
        return
      }
      // 首次展开时拉取内容
      this.$set(this.loadingContent, id, true)
      request_zzquant({
        url: `/market/plate/popular/reason/content?msgid=${id}`,
        noRedirect: true
      })
        .then(res => {
          const d = res && res.data && res.data.data ? res.data.data : null
          const title = d && (d.Title || d.title) ? (d.Title || d.title) : ''
          const contentHtml = d && (d.Content || d.content) ? (d.Content || d.content) : ''
          const createTime = d && (d.CreateTime || d.createTime || d.create_time) ? (d.CreateTime || d.createTime || d.create_time) : null
          this.$set(this.contentMap, id, { title, content: contentHtml, createTime })
          this.$set(this.expanded, id, true)
        })
        .catch(err => {
          console.log(err)
          const msg = (err && err.message) ? String(err.message) : ''
          const hints = ['无权限','未登录','验证失败','Unauthorized','需要登录','未授权']
          const status401 = !!(err && err.status === 401)
          const unauthorized = !!(err && err.__unauthorized)
          const byMsg = hints.some(h => msg.indexOf(h) !== -1)
          this.authRequired = !!(status401 || unauthorized || byMsg)
          this.$set(this.contentMap, id, { title: '', content: '<div style="color:#d23">内容加载失败</div>', createTime: null })
          this.$set(this.expanded, id, true)
        })
        .finally(() => {
          this.$set(this.loadingContent, id, false)
        })
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.plate-kline-modal {
  position: relative;
  width: 80%;
  max-width: 1000px;
  background-color: var(--bg-card);
  color: var(--text-main);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 20px;
}

.plate-kline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  color: var(--text-main);
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-muted);
}

.plate-reasons {
  margin-top: 16px;
  border-top: 1px solid var(--border-color);
  padding-top: 12px;
  max-height: 300px;
  overflow-y: auto;
}
.plate-reasons-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-main);
}
.loading { font-size: 12px; color: var(--text-muted); }
.empty { font-size: 13px; color: var(--text-muted); }
.login-btn{ margin-left:8px; padding:2px 10px; border-radius:16px; font-size:12px; }
.reasons-list { display: flex; flex-direction: column; gap: 10px; }
.reason-item { padding: 8px; border: 1px solid var(--border-color); border-radius: 6px; }
.reason-title { display: flex; gap: 8px; align-items: center; font-weight: 600; }
.reason-title .date { font-size: 12px; color: var(--text-muted); }
.reason-title .boom { font-size: 12px; color: #d23; border: 1px solid #d23; border-radius: 3px; padding: 0 4px; }
.reason-title .title { font-size: 14px; color: var(--accent-color); text-decoration: none; cursor: pointer; }
.reason-meta { display: flex; gap: 12px; font-size: 12px; color: var(--text-muted); margin-top: 4px; }
.reason-text { font-size: 13px; margin-top: 6px; line-height: 1.4; color: #d23;}
.reason-lz { font-size: 12px; margin-top: 4px; color: var(--text-main); }
.reason-content { margin-top: 8px; font-size: 13px; line-height: 1.6; color: var(--text-main);}
.reason-detail-meta { font-size: 12px; color: var(--text-muted); margin-bottom: 6px; }
</style>
    onUserLogin() {
      if (this.visible && this.plateCode) {
        this.authRequired = false
        this.loadReasons()
      }
    },
